import { action, observable } from 'mobx';
import { NotificationService, EnumService } from '../services';
import { EnumEntry, EnumData } from '../models';

export class EnumStore {
    @observable userPermissions: EnumEntry[];
    @observable userRoles: EnumEntry[];

    @observable enumsLoaded: boolean;
    @observable errorLoadingEnums: boolean;

    private enumService: EnumService;

    constructor(notificationService: NotificationService) {
        // init observables
        this.enumsLoaded = false;
        this.userPermissions = [];
        this.userRoles = [];
        this.errorLoadingEnums = false;

        // init class members
        this.enumService = new EnumService(notificationService);
    }

    @action loadEnums() {
        return this.enumService.getEnums()
            .then((enumData: EnumData) => {
                this.userPermissions = enumData.userPermissions;
                this.userRoles = enumData.userRoles;

                this.enumsLoaded = true;
            })
            .catch(() => {
                this.enumsLoaded = false;
                this.errorLoadingEnums = true;
            });
    }
}


// WEBPACK FOOTER //
// ./src/stores/EnumStore.tsx